// fr_pms_housekeeping.ts
// Tłumaczenia dla PMS.Housekeeping.tsx

export const frPmsHousekeeping = {

  title: "Housekeeping",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    roomControl:   "Controle des chambres",
    roomSnapshot:  "Etat des chambres",
    tasks:         "Taches housekeeping",
    maintenance:   "Maintenance et blocage",
    realtimeFeed:  "Fil en direct",
    operations:    "Operations",
  },

  // ── Opisy sekcji ─────────────────────────────────────────────────────────
  descriptions: {
    roomReadiness: "Disponibilite des chambres, gestion des taches, maintenance, blocage et operations en temps reel.",
    fastUpdates:   "Mises a jour rapides du statut des chambres avec persistance securisee.",
    currentState:  "Etat operationnel actuel.",
    createTrack:   "Creez et suivez les taches operationnelles des chambres.",
    escalate:      "Escaladez les incidents techniques et protegez le stock.",
    prepared:      "Prepare pour un futur flux d'evenements sur les appareils du personnel.",
  },

  // ── Typy zadań ────────────────────────────────────────────────────────────
  taskTypes: {
    inspection:       "Inspection",
    turndown:         "Turndown",
    deepClean:        "Nettoyage en profondeur",
    maintenanceFollowUp: "Controle apres maintenance",
    taskType:         "Type de tache",
  },

  // ── Statusy pokoi (specyficzne dla HK) ───────────────────────────────────
  roomStatus: {
    clean:     "Propre",
    dirty:     "Sale",
    cleaning:  "En nettoyage",
    inspected: "Inspecte",
    blocked:   "Bloque",
  },

  // ── Konserwacja i blokowanie ──────────────────────────────────────────────
  maintenance: {
    severity:    "Gravite du defaut",
    blockRoom:   "Bloquer la chambre",
    releaseBlock:"Lever le blocage",
    resolved:    "Resolu par le service, transmis au housekeeping.",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    priority:          "Priorite",
    housekeepingStatus:"Statut housekeeping",
    unassigned:        "Non assigne",
  },

  // ── Komunikaty błędów ─────────────────────────────────────────────────────
  messages: {
    blockFailed:            "Echec du blocage de la chambre.",
    blockReleaseFailed:     "Echec du deblocage.",
    maintenanceReportFailed:"Echec du signalement de maintenance.",
    maintenanceUpdateFailed:"Echec de la mise a jour de maintenance.",
    roomUpdateFailed:       "Echec de la mise a jour de la chambre.",
    taskCreationFailed:     "Echec de la creation de la tache.",
    taskUpdateFailed:       "Echec de la mise a jour de la tache.",
  },

} as const;

export default frPmsHousekeeping;
